<template lang="ES">
        <v-row dense>
            <v-col cols="12" md="4">
                <v-col cols="12">
                    <v-card >
                        <v-card-title>{{ comision.Asignatura }}</v-card-title>
                        <v-card-text >
                            <v-row dense>
                                <v-col cols="12" >
                                    <!-- <p><strong>Comision:</strong> {{ comision.NombreComision }}</p> -->
                                    <p><strong>Grupo:</strong> {{ comision.Grupo }}</p>
                                    <p><strong>DNI:</strong> {{ comision.Docente.split("-")[0] }}</p>
                                    <p><strong>Docentes:</strong> {{ comision.Docente.split("-")[1] }}</p>
                                    <p><strong>Cantidad de encuentros:</strong> {{ comision.Ponderacion }}</p>
                                    <p><strong>Dia/Horario:
                                        </strong> {{ comision.Horario }} 
                                        <!-- <v-chip color="orange" outlined small>Sin disponibilidad en este horario</v-chip></p> -->
                                    <p v-if="comision.Faltante != 0" >
                                        <strong>Faltantes:</strong> 
                                        <v-chip color="red" dark>{{ comision.Faltante }}</v-chip>
                                    </p>
                                    <div v-if="comision.tutorias && comision.tutorias.length > 0">
                                        <strong>Tutorías:</strong>
                                        <ul>
                                            <li v-for="(tutoria, index) in comision.tutorias" :key="index">
                                                {{ formatTutoriaDate(tutoria.fecha) }} {{ tutoria.hora }}
                                            </li>
                                        </ul>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12">
                    <ListaDisponibilidad :detalle="detalle" @notify="obtenerDias"> </ListaDisponibilidad>
                </v-col>
            </v-col>
            <v-col cols="12" md="8">
                <PlaniCalendario :dias="dias" @click-dia="clickDia"/>
            </v-col>
        </v-row>
</template>
<script>
import Planificador from "../../services/Planificador.service";
import PlaniCalendario from "../../components/planificacdor/PlaniCalendario.vue"
import ListaDisponibilidad from "../../components/planificacdor/ListaDiponibilidad.vue"
export default {
    props: {
        comision: {
            type: null,
            required: true,
        }
    },
    components: {
        PlaniCalendario,
        ListaDisponibilidad
    },
    data() {
        return {
            data: [],
            dias: null,
            detalle: null
        }
    },
    methods: {
        obtenerDias(value) {
            Planificador.ObtenerDiasDisponibles(this.comision.Id).then((result) => {
                /*const map = new Map();
                 result.data.forEach(({ fecha, hora, estado }) => {
                        if (!map.has(fecha)) map.set(fecha, []);
                            map.get(fecha).push({ hora, estado });
                });
*/
                this.data = result.data;
                
                const registrosFiltrados = result.data.filter(r => {
                    if(this.comision.Modalidad==="D")return true;
                    // Mantener registros con estado 1 que coincidan con la hora específica
                    if (r.estado === 1) {
                        return r.hora.startsWith(this.comision.Horario.trim());
                    }
                    // Mantener todos los registros con otros estados
                    return true;
                });
                //console.log(registrosFiltrados);
                this.dias = new Map(registrosFiltrados.map(r => [r.fecha, r.estado]));
            }).catch((err) => {
            });

        },
        async ObtenerDetalle() {
            try {
                const response = await Planificador.ObtenerDetalle(this.comision.Id);
                this.detalle = response.data;
            } catch (error) {
                console.error("Error al obtener los detalles:", error);
            }
        },
        clickDia(dia) {
            Planificador.AgregarTutoria(this.comision.Id, dia).then((result) => {
                this.obtenerDias(true);     
            }).catch((err) => {
                
            });
            /*  const date = day;
             ///this.loading = true; // Muestra indicador
             try {
                 // Lógica para habilitar/deshabilitar días
                 const response = await Planificador.novedadDia({
                     dia: date,
                 });
                 if (response.status === 200) {
                     this.loadDisabledDays();
                 }
             } catch (error) {
                 console.error("Error al actualizar día:", error);
             } finally {
                 //this.loading = false; // Oculta indicador
             } */

        }

    },
    mounted() {
        this.ObtenerDetalle();
        this.obtenerDias();
    },

}
</script>
<style lang="">

</style>